export default `
<article class="clearfix">
  <a class="article-user" ui-sref="profile.about({profileId: $ctrl.user.slug})" ng-click="$ctrl.close()">
      <div class="profile-thumb" bg-img="{{$ctrl.user.avatar_url}}"></div>
      <div class="profile-slug">@{{$ctrl.user.slug}}</div><span class="profile-name">{{$ctrl.user.name}}</span>
  </a>
  <ut-community-follow-btn [user]="$ctrl.user" ng-if="$ctrl.user.current_user_permissions['follow']"></ut-community-follow-btn>
</article>
`;
